import { render, staticRenderFns } from "./asideLayout.vue?vue&type=template&id=f9347166&scoped=true"
import script from "./asideLayout.vue?vue&type=script&lang=js"
export * from "./asideLayout.vue?vue&type=script&lang=js"
import style0 from "./asideLayout.vue?vue&type=style&index=0&id=f9347166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9347166",
  null
  
)

export default component.exports